import { render } from "./Inputi18nInline.vue?vue&type=template&id=6c0ea200&scoped=true"
import script from "./Inputi18nInline.vue?vue&type=script&lang=js"
export * from "./Inputi18nInline.vue?vue&type=script&lang=js"

import "./Inputi18nInline.vue?vue&type=style&index=0&id=6c0ea200&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c0ea200"]])

export default __exports__